import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Button, FormControlLabel, Stack, Switch } from '@mui/material';
import { CardContainer } from 'components/shared/CardContainer/CardContainer';

import { ViewSettings } from '../../types';
import { ListSection } from './ListSection';
import { applyViewSettings } from '../../lib';
import { TemplatesResponse, useBPFMutations } from '../../api';

interface Props {
  templates: TemplatesResponse['bpf']['templates'];
}

export const TemplatesList = ({ templates }: Props) => {
  const { push } = useHistory();
  const { handleSetActiveStatus, isActiveStatusSetting } = useBPFMutations();

  const [viewSettings, setViewSettings] = useState<ViewSettings>({ showInactive: false });

  const handleRedirectToCreateTemplatePage = () => {
    push({
      pathname: '/bpf/template',
      search: '?mode=create',
    });
  };

  const handleRedirectToCopyTemplatePage = (templateId: string) => {
    push({
      pathname: `/bpf/template/${templateId}`,
      search: '?mode=copy',
    });
  };

  const handleEditTemplatePage = (templateId: string) => {
    push({
      pathname: `/bpf/template/${templateId}`,
      search: '?mode=edit',
    });
  };

  const handleRedirectToCloseReasonConfigurationPage = (templateId: string) => {
    push(`/bpf/closeReasonConfiguration/${templateId}`);
  };

  const handleRedirectToDepartmentsManagementPage = () => {
    push('/bpf/departments');
  };

  const handleRedirectToAuditLogPage = () => {
    push('/bpf/auditLog');
  };

  return (
    <CardContainer
      title="Deal Stages"
      actionBtn={
        <Stack direction="row" gap="0.5rem">
          <FormControlLabel
            label="Show Inactive"
            control={
              <Switch
                checked={viewSettings.showInactive}
                onChange={(_, checked) => setViewSettings(prev => ({ ...prev, showInactive: checked }))}
              />
            }
          />

          <Button size="small" onClick={handleRedirectToAuditLogPage}>
            Audit Log
          </Button>

          <Button size="small" onClick={handleRedirectToDepartmentsManagementPage}>
            Update Departments
          </Button>

          <Button size="small" variant="contained" onClick={handleRedirectToCreateTemplatePage}>
            Create New template
          </Button>
        </Stack>
      }
    >
      <Stack gap="1rem">
        {templates.map(({ templates, department }, index) => (
          <ListSection
            renderIndex={index}
            department={department}
            key={`${department.id}-${index}`}
            isActiveStatusSetting={isActiveStatusSetting}
            templates={applyViewSettings(templates, viewSettings)}
            actions={{
              onEditTemplate: handleEditTemplatePage,
              onCopyTemplate: handleRedirectToCopyTemplatePage,
              onRedirectToCloseReasons: handleRedirectToCloseReasonConfigurationPage,
              onSetActiveStatus: templateId => handleSetActiveStatus(templateId, department.id),
            }}
          />
        ))}
      </Stack>
    </CardContainer>
  );
};
